/* eslint-disable import/prefer-default-export */
import isNil from 'lodash/isNil';
import { closeFaultAnalysisPopup, isShowFaultAnalysisPopup, closeEventSmartAnalyzerPopup, isShowEventSmartAnalyzerPopup } from '@/utils/event';
import store from '@/store';

/**
 * 열려져 있는 프레임 영역 팝업을 닫는다.
 * TODO 추후 유지보수 효율성을 위해 추후 각 store dispath 상수값으로 관리 필요.
 * @author Ju
 */
export function closeOpenFramePopup() {
  // 장애 분석 팝업
  if (isShowFaultAnalysisPopup()) {
    closeFaultAnalysisPopup();
  }
  // 이벤트 스마트 분석 팝업
  if (isShowEventSmartAnalyzerPopup()) {
    closeEventSmartAnalyzerPopup();
  }
  // 즐겨찾기 팝업
  if (store.state.popup.showFavoritePopup) {
    store.dispatch('closeFavoritePopup');
  }
  // 사용자 정보 팝업
  if (store.state.popup.showUserPopup) {
    store.dispatch('closeUserPopup');
  }
  // 이벤트 이력 / 사전 예측 이벤트 이력 팝업 (푸시 알림)
  if (store.state.popup.showCommonEventHistPopup) {
    store.dispatch('closeCommonEventHistPopup');
  }
  // 정기점검 변경 이력 팝업 (푸시 알림)
  if (store.state.popup.showRegularCheckDetailInfoPopup) {
    store.dispatch('closeRegularCheckDetailInfoPopup');
  }
  // 작업 목록 팝업 (푸시 알림)
  if (store.state.popup.showWorkDetailPopup) {
    store.dispatch('closeWorkDetailPopup');
  }
  // 작업 상세 팝업 (푸시 알림)
  if (store.state.popup.showWorkDetailsSlidingPopup) {
    store.dispatch('closeWorkDetailsSlidingPopup');
  }
  // 이벤트 타임라인 팝업
  if (store.state.popup.showEventTimelinePopup) {
    store.dispatch('closeEventTimelinePopup');
  }
  // Smart Search 팝업
  if (store.state.popup.showSmartSearchPopup) {
    store.dispatch('closeSmartSearchPopup');
  }
}

export function setVModalClassBySlidingType() {
  const vModalEl = document.querySelector('div.v-modal');
  if (!isNil(vModalEl)) {
    if (store.getters.showSettingView) {
      if (vModalEl.className.indexOf('setting-sliding') < 0) {
        vModalEl.className = vModalEl.className.replace('sliding', 'setting-sliding');
      }
    } else if (vModalEl.className.indexOf('setting-sliding') >= 0) {
      vModalEl.className = vModalEl.className.replace('setting-sliding', 'sliding');
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/popup.js